module.exports = __webpack_public_path__ + "img/llaclass.ea083f58.png";